import { render, staticRenderFns } from "./ParentsChildrenList.vue?vue&type=template&id=65906f3a&"
import script from "./ParentsChildrenList.vue?vue&type=script&lang=js&"
export * from "./ParentsChildrenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports